/* TrendoraHub storefront helpers: wishlist, recently viewed, delivery estimate.
   Stored in the shopper's own browser (localStorage). No app required. */
(function () {
  'use strict';
  var WISH_KEY = 'th:wishlist';
  var RECENT_KEY = 'th:recent';
  var RECENT_MAX = 16;

  function read(key) { try { return JSON.parse(localStorage.getItem(key)) || []; } catch (e) { return []; } }
  function write(key, value) { try { localStorage.setItem(key, JSON.stringify(value)); } catch (e) {} }

  var HEART = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 20s-7.5-4.6-9.2-9.4C1.6 7.2 3.8 4 7.2 4c2 0 3.6 1.1 4.8 2.8C13.2 5.1 14.8 4 16.8 4c3.4 0 5.6 3.2 4.4 6.6C19.5 15.4 12 20 12 20z"/></svg>';

  /* Wishlist */
  var wishlist = read(WISH_KEY);
  function isWished(handle) { return wishlist.indexOf(handle) !== -1; }

  function setWished(handle, on) {
    wishlist = wishlist.filter(function (h) { return h !== handle; });
    if (on) wishlist.unshift(handle);
    write(WISH_KEY, wishlist);
    syncWishButtons();
    document.dispatchEvent(new CustomEvent('th:wishlist-change', { detail: { wishlist: wishlist.slice() } }));
  }

  function syncWishButtons() {
    document.querySelectorAll('[data-th-wish-toggle]').forEach(function (btn) {
      var on = isWished(btn.getAttribute('data-th-wish-toggle'));
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = btn.querySelector('[data-th-wish-label]');
      if (label) {
        if (!label.dataset.offText) label.dataset.offText = label.textContent;
        var next = on ? 'Saved to wishlist' : label.dataset.offText;
        if (label.textContent !== next) label.textContent = next;
      } else {
        btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Save to wishlist');
      }
    });
  }

  function handleFromHref(href) {
    var m = /\/products\/([^/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : null;
  }

  // Adds a heart to every product card the theme renders (grids, carousels, search, recommendations).
  function decorateCards(root) {
    var added = 0;
    (root || document).querySelectorAll('product-card, .th-mini').forEach(function (card) {
      if (card.querySelector('.th-wish')) return;
      var link = card.querySelector('a[href*="/products/"]');
      var handle = card.getAttribute('data-th-handle') || (link && handleFromHref(link.getAttribute('href')));
      if (!handle) return;
      if (getComputedStyle(card).position === 'static') card.style.position = 'relative';
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'th-wish';
      btn.setAttribute('data-th-wish-toggle', handle);
      btn.innerHTML = HEART;
      card.appendChild(btn);
      added++;
    });
    if (added) syncWishButtons();
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-th-wish-toggle]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    var handle = btn.getAttribute('data-th-wish-toggle');
    setWished(handle, !isWished(handle));
  }, true);

  /* Recently viewed */
  function trackView() {
    var handle = window.TH && window.TH.productHandle;
    if (!handle) return;
    var list = read(RECENT_KEY).filter(function (h) { return h !== handle; });
    list.unshift(handle);
    write(RECENT_KEY, list.slice(0, RECENT_MAX));
  }

  /* Product strips (recent + wishlist) */
  var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  var money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: currency });

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function cardHTML(p) {
    var overrides = {};
    document.querySelectorAll('[data-th-image-map]').forEach(function (el) {
      try { Object.assign(overrides, JSON.parse(el.textContent)); } catch (error) {}
    });
    var featured = overrides[p.handle] || p.featured_image;
    var imageURL = featured ? new URL(featured, location.origin) : null;
    if (imageURL) imageURL.searchParams.set('width', '600');
    var img = featured
      ? '<img src="' + esc(imageURL.href) + '" alt="' + esc(p.title) + '" loading="lazy" width="600" height="600">'
      : '<div class="th-ph" role="img" aria-label="No image yet"></div>';
    var compare = p.compare_at_price && p.compare_at_price > p.price ? '<s>' + money.format(p.compare_at_price / 100) + '</s>' : '';
    if (compare && (p.tags || []).indexOf('trendora-bundle') !== -1) {
      var labels = {};
      try { labels = JSON.parse(document.querySelector('[data-th-offer-labels]').textContent); } catch (error) {}
      compare = '<small class="th-offer-reference">' + esc(labels.separately || 'Bought separately') + ' ' + compare + '</small>';
    }
    return '<div class="th-mini" data-th-handle="' + esc(p.handle) + '">' +
      '<a class="th-card-link" href="' + esc(p.url || '/products/' + p.handle) + '">' +
      '<div class="th-mini__img">' + img + '</div>' +
      '<div class="th-mini__title">' + esc(p.title) + '</div>' +
      '<div class="th-mini__price">' + money.format(p.price / 100) + compare + '</div>' +
      '</a></div>';
  }

  function fetchProduct(handle) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function renderStrip(section) {
    var mode = section.getAttribute('data-th-product-strip');
    var limit = parseInt(section.getAttribute('data-th-limit'), 10) || 4;
    var exclude = section.getAttribute('data-th-exclude');
    var grid = section.querySelector('[data-th-strip-grid]');
    var empty = section.querySelector('[data-th-strip-empty]');
    var handles = (mode === 'wishlist' ? wishlist : read(RECENT_KEY))
      .filter(function (h) { return h && h !== exclude; })
      .slice(0, limit);

    function showEmpty() {
      grid.innerHTML = '';
      if (mode === 'recent') section.hidden = true;
      if (empty) empty.hidden = false;
    }
    if (!handles.length) { showEmpty(); return; }

    Promise.all(handles.map(fetchProduct)).then(function (products) {
      products = products.filter(Boolean);
      if (!products.length) { showEmpty(); return; }
      grid.innerHTML = products.map(cardHTML).join('');
      section.hidden = false;
      if (empty) empty.hidden = true;
      decorateCards(grid);
    });
  }

  function renderStrips() { document.querySelectorAll('[data-th-product-strip]').forEach(renderStrip); }

  document.addEventListener('th:wishlist-change', function () {
    document.querySelectorAll('[data-th-product-strip="wishlist"]').forEach(renderStrip);
  });

  /* Delivery estimate */
  function addBusinessDays(date, days) {
    var d = new Date(date);
    var count = 0;
    while (count < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) count++;
    }
    return d;
  }

  function renderEta() {
    var fmt = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    document.querySelectorAll('[data-th-eta]').forEach(function (el) {
      var min = parseInt(el.getAttribute('data-min'), 10);
      var max = parseInt(el.getAttribute('data-max'), 10);
      var target = el.querySelector('[data-th-eta-text]');
      if (!target || isNaN(min) || isNaN(max)) return;
      var now = new Date();
      target.textContent = 'Estimated delivery ' + fmt.format(addBusinessDays(now, min)) + ' – ' + fmt.format(addBusinessDays(now, max)) + '.';
    });
  }

  /* Boot */
  function init() {
    trackView();
    decorateCards(document);
    syncWishButtons();
    renderStrips();
    renderEta();
    var pending = null;
    new MutationObserver(function () {
      if (pending) return;
      pending = requestAnimationFrame(function () { pending = null; decorateCards(document); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function () {
    decorateCards(document);
    renderStrips();
    renderEta();
  });
})();
